export const ADD_TO_CART = "ADD_TO_CART";
export const SET_CART_ITEMS = "SET_CART_ITEMS";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const EMPTY_CART = "EMPTY_CART";

export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";
export const SAVE_SHIPPING_ESTIMATE = "SAVE_SHIPPING_ESTIMATE";